import { createAction, props } from '@ngrx/store';
import { StoreRes } from 'src/app/share/types';

export const setStoreInfo = createAction(
  '[Store Page] Set store information',
  props<StoreRes>()
);
